import { Injectable } from '@angular/core';
import {
  LastPvpFightByHeroGQL,
  BossCompletedAfterTimestampGQL,
  ChamberEntity,
  ChamberGQL,
  DailyActivityCompletedDataGQL,
  DailyActivityCompletedDataQuery,
  DungeonEntity,
  DungeonGQL,
  FirstBossCompletedByHeroGQL,
  FirstBossCompletedByUserGQL,
  FirstBossCompletedEntity,
  FreeDungeonsGQL,
  GeneralTokenomicsDataGQL,
  GeneralTokenomicsDataQuery,
  GlobalCustomDataEntity,
  GlobalCustomDataGQL,
  GraphDataGQL,
  GraphDataQuery,
  GuildEntity,
  GuildGQL,
  GuildMemberEntity,
  GuildMemberGQL,
  GuildRequestByGuildDataGQL,
  GuildRequestByUserDataGQL,
  GuildRequestEntity,
  GuildsDataGQL,
  HeroAction,
  HeroActionsByTimeAndFromTimestampGQL,
  HeroCustomData,
  HeroCustomDataGQL,
  HeroEntity,
  HeroEntity_OrderBy,
  HeroesByBiomeDataGQL,
  HeroesForFightGQL,
  HeroesForGuildStakeGQL,
  HeroesInAddressDataGQL,
  HeroesMetaByAddressGQL,
  HeroesMetaGQL,
  HeroesRefCodeByAddressGQL,
  HeroesRefCodeGQL,
  HeroesTopListAccountGQL,
  HeroesTopListGQL,
  HeroGQL,
  HeroMetaEntity,
  ItemEntity,
  ItemGQL,
  ItemMetaEntity,
  ItemMetaInAddressGQL,
  ItemMetaListGQL,
  ItemUnionEntity,
  ItemUnionListGQL,
  LastItemOwnerGQL,
  LeaderboardByUserGQL,
  LeaderboardByWeekGQL,
  LeaderboardFromWeekGQL,
  LeaderboardTotalPointsGQL,
  LootBoxDataGQL,
  LootBoxDataQuery,
  LootBoxOpenedDataGQL,
  LootBoxOpenedDataQuery,
  OpenedChamberGQL,
  OrderDirection,
  PawnshopEntity,
  PawnshopGQL,
  PawnshopHistoryGQL,
  PawnshopPositionEntity,
  PawnshopPositionFloorGQL,
  PawnshopPositionHistoryEntity,
  PawnshopPositionsGQL,
  PvpFightByEpochWeekDataGQL,
  PvpFightEntity,
  PvpFightGQL,
  PvpGuildByGuildGQL,
  PvpGuildEntity,
  PvpGuildLeaderboardGQL,
  RewardPoolEntity,
  RewardPoolGQL,
  StoryEntity,
  StoryGQL,
  TierDataGQL,
  TierEntity,
  TokenEntity,
  TokenGQL,
  TokenTransactionEntity,
  TokenTransactionsFromGQL,
  TokenTransactionsToGQL,
  TransactionsGtTimestapDataGQL,
  UserBossCompletedEntity,
  UserGQL,
  UserItemsGQL,
  UserLastActionGQL,
  UserQuery,
  UserStatGQL,
  WeekTotalAirdropEntity,
  WeekUserAirdropStatEntity,
  GuildMembersGQL,
  UserStatQuery,
  PvpGuildLeaderboardInWeekGQL,
  HeroSandboxItemsGQL,
  GuildReinforcementGQL,
  GuildReinforcementEntity,
  LastPvpFightByAccountGQL,
  WeekAirdropRootsGQL,
  BossCompletedBetweenTimestampGQL,
  WeekAirdropRootEntity,
  UserConsGQL,
  PvpFightListByGuildDataGQL,
  ShelterItemsByDayAndGuildDataGQL,
  ShelterItemLimitEntity,
  ItemByOwnerAndMetaNameGQL,
  TransactionsDataGQL,
  GasWeekAirdropByUserGQL,
  TransactionEntity,
  WeekGasUserAirdropStatEntity,
  UserItemsCountGQL,
  UserOtherUseGQL,
  PvpFightsBetweenTimestampGQL,
  HeroPvpFightHistoryEntity,
  PvpFightFromEpochWeekDataGQL,
  PvpGuildHeroByEpochWeekDataGQL,
  PvpGuildHeroEntity,
  GuildStakeEntity,
  GuildsStakeDataGQL,
  ItemsInIdsGQL,
  SheltersDataGQL,
  ShelterAuctionsDataGQL,
  PvpGuildHeroByEpochWeekAndBiomeDataGQL,
  ShelterEntity,
  ShelterAuctionEntity,
  OpenedChamberEntity,
  BossCompletedBetweenTimestampWithoutBlockGQL,
} from '@generated/gql';
import { DestroyService } from '@services/destroy.service';
import { BaseSubgraphService } from '@services/graph/base-subgraph.service';
import { isExpiredItem } from '@shared/utils/item-utils';
import { ethers } from 'ethers';
import { NGXLogger } from 'ngx-logger';
import { expand, filter, map, Observable, retry, tap, EMPTY, forkJoin, reduce } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SubgraphService extends BaseSubgraphService {
  // public lastSubgraphData = new Subject<GraphDataQuery['_meta']>();
  public currentSubgraphBlock?: number;
  public currentSubgraphDelaySec?: number;

  constructor(
    private userGQL: UserGQL,
    private userLastActionGQL: UserLastActionGQL,
    private tokenGQL: TokenGQL,
    private itemGQL: ItemGQL,
    private chamberGQL: ChamberGQL,
    private dungeonGQL: DungeonGQL,
    private freeDungeonsGQL: FreeDungeonsGQL,
    private heroGQL: HeroGQL,
    private guildGQL: GuildGQL,
    private guildMemberGQL: GuildMemberGQL,
    private heroesMetaGQL: HeroesMetaGQL,
    private heroesTopListGQL: HeroesTopListGQL,
    private pawnshopGQL: PawnshopGQL,
    private openedChamberGQL: OpenedChamberGQL,
    private pawnshopPositionsGQL: PawnshopPositionsGQL,
    private userItemsGQL: UserItemsGQL,
    private userConsGQL: UserConsGQL,
    private userOtherUseGQL: UserOtherUseGQL,
    private heroSandboxItemsGQL: HeroSandboxItemsGQL,
    private graphDataGQL: GraphDataGQL,
    private heroMetaByAddressGQL: HeroesMetaByAddressGQL,
    private heroCustomDataGQL: HeroCustomDataGQL,
    private globalCustomDataGQL: GlobalCustomDataGQL,
    private generalTokenomicsDataGQL: GeneralTokenomicsDataGQL,
    private heroesTopListAccountGQL: HeroesTopListAccountGQL,
    private userStatGQL: UserStatGQL,
    private heroesRefCodeGQL: HeroesRefCodeGQL,
    private heroesRefCodeByAddressGQL: HeroesRefCodeByAddressGQL,
    private dailyActivityCompletedGQL: DailyActivityCompletedDataGQL,
    private lootBoxGQL: LootBoxDataGQL,
    private lootBoxOpenedGQL: LootBoxOpenedDataGQL,
    private pawnshopHistoryGQL: PawnshopHistoryGQL,
    private itemMetaListGQL: ItemMetaListGQL,
    private lastItemOwnerGQL: LastItemOwnerGQL,
    private pawnshopPositionFloorGQL: PawnshopPositionFloorGQL,
    private storyGQL: StoryGQL,
    private rewardPoolGQL: RewardPoolGQL,
    private heroesInAddressDataGQL: HeroesInAddressDataGQL,
    private transactionGtTimestampData: TransactionsGtTimestapDataGQL,
    private tokenTransactionFromGQL: TokenTransactionsFromGQL,
    private tokenTransactionsToGQL: TokenTransactionsToGQL,
    private itemUnionListGQL: ItemUnionListGQL,
    private firstBossCompletedByUserGQL: FirstBossCompletedByUserGQL,
    private firstBossCompletedByHeroGQL: FirstBossCompletedByHeroGQL,
    private tierGQL: TierDataGQL,
    private heroesByBiomeDataGQL: HeroesByBiomeDataGQL,
    private guildsDataGQL: GuildsDataGQL,
    private itemMetaInAddressGQL: ItemMetaInAddressGQL,
    private heroesForGuildStakeGQL: HeroesForGuildStakeGQL,
    private guildRequestByUserDataGQL: GuildRequestByUserDataGQL,
    private guildRequestByGuildGQL: GuildRequestByGuildDataGQL,
    private pvpGuildByGuildGQL: PvpGuildByGuildGQL,
    private heroesForFightGQL: HeroesForFightGQL,
    private shelterItemsByDayAndGuildDataGQL: ShelterItemsByDayAndGuildDataGQL,
    private pvpGuildLeaderboardGQL: PvpGuildLeaderboardGQL,
    private pvpFightGQL: PvpFightGQL,
    private pvpFightByEpochWeekGQL: PvpFightByEpochWeekDataGQL,
    private lastPvpFightByHeroGQL: LastPvpFightByHeroGQL,
    private lastPvpFightByAccountGQL: LastPvpFightByAccountGQL,
    private bossCompletedAfterTimestampGQL: BossCompletedAfterTimestampGQL,
    private guildMembersGQL: GuildMembersGQL,
    private leaderboardFromWeekGQL: LeaderboardFromWeekGQL,
    private leaderboardByWeekGQL: LeaderboardByWeekGQL,
    private leaderboardByUserGQL: LeaderboardByUserGQL,
    private leaderboardTotalPointsGQL: LeaderboardTotalPointsGQL,
    private pvpGuildLeaderboardInWeek: PvpGuildLeaderboardInWeekGQL,
    private heroActionsByTimeAndFromTimestampGQL: HeroActionsByTimeAndFromTimestampGQL,
    private guildReinforcementGQL: GuildReinforcementGQL,
    private itemByOwnerAndMetaNameGQL: ItemByOwnerAndMetaNameGQL,
    private bossCompletedBetweenTimestamp: BossCompletedBetweenTimestampGQL,
    private weekAirdropRootFromWeek: WeekAirdropRootsGQL,
    private pvpFightListByGuildDataGQL: PvpFightListByGuildDataGQL,
    private transactionsDataGQL: TransactionsDataGQL,
    private gasWeekAirdropByUserGQL: GasWeekAirdropByUserGQL,
    private pvpFightsBetweenTimestampGQL: PvpFightsBetweenTimestampGQL,
    private userItemsCountGQL: UserItemsCountGQL,
    private pvpFightFromEpochWeekDataGQL: PvpFightFromEpochWeekDataGQL,
    private pvpGuildHeroByEpochWeekDataGQL: PvpGuildHeroByEpochWeekDataGQL,
    private pvpGuildHeroByEpochWeekAndBiomeDataGQL: PvpGuildHeroByEpochWeekAndBiomeDataGQL,
    private guildsStakeDataGQL: GuildsStakeDataGQL,
    private itemsInIdsGQL: ItemsInIdsGQL,
    private sheltersDataGQL: SheltersDataGQL,
    private shelterAuctionsDataGQL: ShelterAuctionsDataGQL,
    private bossCompletedBetweenTimestampWithoutBlockGQL: BossCompletedBetweenTimestampWithoutBlockGQL,
    private logger: NGXLogger,
    private destroy$: DestroyService,
  ) {
    super();
    // timer(0, 5_000)
    //   .pipe(
    //     switchMap(() => this.graphData$()),
    //     takeUntil(this.destroy$),
    //   )
    //   .subscribe(data => {
    //     if (data) {
    //       if (data.hasIndexingErrors) {
    //         this.logger.error('Subgraph has indexing errors!');
    //       } else {
    //         this.lastSubgraphData.next(data);
    //         this.currentSubgraphBlock = data.block.number;
    //         this.currentSubgraphDelaySec = Math.floor(Date.now() / 1000 - (data.block.timestamp ?? 0));
    //         // this.logger.trace('Current subgraph block', this.currentSubgraphBlock, this.currentSubgraphDelaySec);
    //       }
    //     }
    //   });
  }

  graphData$(): Observable<GraphDataQuery['_meta']> {
    return this.graphDataGQL.fetch().pipe(
      map(x => x.data._meta),
      tap(data => {
        if (data) {
          this.currentSubgraphBlock = data.block.number;
          this.currentSubgraphDelaySec = Math.floor(Date.now() / 1000 - (data.block.timestamp ?? 0));
        }
      }),
      retry(this.retry()),
    );
  }

  user$(account: string): Observable<UserQuery['userEntity']> {
    return this.userGQL.fetch({ account: account.toLowerCase() }).pipe(
      map(x => x.data.userEntity),
      retry(this.retry()),
    );
  }

  userLastActionBlock$(account: string): Observable<number> {
    return this.userLastActionGQL.fetch({ account: account.toLowerCase() }).pipe(
      map(x => x.data.userEntity?.lastActionBlock ?? 0),
      retry(this.retry()),
    );
  }

  dailyActivityCompleted$(
    account: string,
    first: number = 7,
  ): Observable<DailyActivityCompletedDataQuery['dailyActivityCompletedEntities']> {
    return this.dailyActivityCompletedGQL.fetch({ user: account.toLowerCase(), first: first }).pipe(
      map(x => x.data.dailyActivityCompletedEntities),
      retry(this.retry()),
    );
  }

  lastLootBoxOpened$(
    account: string,
    lootBoxKind: string,
  ): Observable<LootBoxOpenedDataQuery['lootBoxOpenedHistoryEntities']> {
    return this.lootBoxOpenedGQL.fetch({ user: account.toLowerCase(), lootBoxKind: lootBoxKind }).pipe(
      map(x => x.data.lootBoxOpenedHistoryEntities),
      retry(this.retry()),
    );
  }

  lootBox$(): Observable<LootBoxDataQuery['lootBoxEntities']> {
    return this.lootBoxGQL.fetch().pipe(
      map(x => x.data.lootBoxEntities),
      retry(this.retry()),
    );
  }

  userStat$(account: string): Observable<UserStatQuery['userStatEntity']> {
    return this.userStatGQL.fetch({ account: account.toLowerCase() }).pipe(
      map(x => x.data.userStatEntity),
      retry(this.retry()),
    );
  }

  token$(tokenAdr: string): Observable<TokenEntity> {
    return this.tokenGQL.fetch({ tokenAdr: tokenAdr.toLowerCase() }).pipe(
      map(x => x.data.tokenEntity as TokenEntity),
      retry(this.retry()),
    );
  }

  generalTokenomics$(): Observable<GeneralTokenomicsDataQuery['generalTokenomicsEntities']> {
    return this.generalTokenomicsDataGQL.fetch().pipe(
      map(x => x.data.generalTokenomicsEntities),
      retry(this.retry()),
    );
  }

  openedChamber$(
    dungAdr: string,
    chamberAdr: string,
    heroAdr: string,
    heroId: number,
    stage: number,
    iteration: number,
  ): Observable<OpenedChamberEntity> {
    this.logger.trace('openedChamber$', dungAdr, chamberAdr, heroAdr, heroId, stage, iteration);
    const chamberId = ethers.keccak256(
      ethers.toUtf8Bytes(
        dungAdr.toLowerCase() + chamberAdr.toLowerCase() + heroAdr.toLowerCase() + heroId + stage + iteration,
      ),
    );
    return this.openedChamberGQL.fetch({ chamberId: chamberId }).pipe(
      map(x => x.data.openedChamberEntity as OpenedChamberEntity),
      retry(this.retry()),
    );
  }

  item$(itemAdr: string, itemId: number): Observable<ItemEntity> {
    return this.itemGQL.fetch({ itemGraphId: itemAdr.toLowerCase() + '-' + itemId.toString() }).pipe(
      map(x => x.data.itemEntity as ItemEntity),
      retry(this.retry()),
    );
  }

  hero$(heroAdr: string, heroId: number): Observable<HeroEntity> {
    return this.heroGQL.fetch({ heroGraphId: heroAdr.toLowerCase() + '-' + heroId.toString() }).pipe(
      map(x => x.data.heroEntity as HeroEntity),
      retry(this.retry()),
    );
  }

  pvpFight$(id: string): Observable<PvpFightEntity> {
    return this.pvpFightGQL.fetch({ id }).pipe(
      map(x => x.data.pvpFightEntity as PvpFightEntity),
      retry(this.retry()),
    );
  }

  guild$(id: string): Observable<GuildEntity> {
    return this.guildGQL.fetch({ id }).pipe(
      map(x => x.data.guildEntity as GuildEntity),
      retry(this.retry()),
    );
  }

  guildMember$(id: string): Observable<GuildMemberEntity> {
    return this.guildMemberGQL.fetch({ id }).pipe(
      map(x => x.data.guildMemberEntity as GuildMemberEntity),
      retry(this.retry()),
    );
  }

  lastPvpFightByHero$(heroId: string, epochWeek: string, completed: boolean): Observable<PvpFightEntity[]> {
    return this.lastPvpFightByHeroGQL.fetch({ heroId, epochWeek, completed }).pipe(
      map(x => (x?.data?.pvpFightEntities ?? []) as PvpFightEntity[]),
      retry(this.retry()),
    );
  }

  lastPvpFightByAccount$(account: string, epochWeek: string, completed: boolean): Observable<PvpFightEntity[]> {
    return this.lastPvpFightByAccountGQL.fetch({ account, epochWeek, completed }).pipe(
      map(x => (x?.data?.pvpFightEntities ?? []) as PvpFightEntity[]),
      retry(this.retry()),
    );
  }

  lastPvpFightByGuild$(guild: string, first: number, skip: number): Observable<PvpFightEntity[]> {
    return this.pvpFightListByGuildDataGQL.fetch({ guild, first, skip }).pipe(
      map(x => (x?.data?.pvpFightEntities ?? []) as PvpFightEntity[]),
      retry(this.retry()),
    );
  }

  lastPvpFightFromWeek$(week: string, first: number, skip: number): Observable<PvpFightEntity[]> {
    return this.pvpFightFromEpochWeekDataGQL.fetch({ epochWeek: week, first, skip }).pipe(
      map(x => (x?.data?.pvpFightEntities ?? []) as PvpFightEntity[]),
      retry(this.retry()),
    );
  }

  pvpGuildHeroByWeek$(week: string, first: number, skip: number): Observable<PvpGuildHeroEntity[]> {
    return this.pvpGuildHeroByEpochWeekDataGQL.fetch({ epochWeek: week, first, skip }).pipe(
      map(x => (x?.data?.pvpGuildHeroEntities ?? []) as PvpGuildHeroEntity[]),
      retry(this.retry()),
    );
  }

  pvpGuildHeroByWeekAndBiome$(
    week: string,
    biome: number,
    first: number,
    skip: number,
  ): Observable<PvpGuildHeroEntity[]> {
    return this.pvpGuildHeroByEpochWeekAndBiomeDataGQL.fetch({ epochWeek: week, biome, first, skip }).pipe(
      map(x => (x?.data?.pvpGuildHeroEntities ?? []) as PvpGuildHeroEntity[]),
      retry(this.retry()),
    );
  }

  guildStakeData$(first: number, skip: number): Observable<GuildStakeEntity[]> {
    return this.guildsStakeDataGQL.fetch({ first, skip }).pipe(
      map(x => (x?.data?.guildStakeEntities ?? []) as GuildStakeEntity[]),
      retry(this.retry()),
    );
  }

  itemsInIds$(ids: string[]): Observable<ItemEntity[]> {
    return this.itemsInIdsGQL.fetch({ ids }).pipe(
      map(x => (x?.data?.itemEntities ?? []) as ItemEntity[]),
      retry(this.retry()),
    );
  }

  transactions$(first: number, skip: number): Observable<TransactionEntity[]> {
    return this.transactionsDataGQL.fetch({ first, skip }).pipe(
      map(x => (x?.data?.transactionEntities ?? []) as TransactionEntity[]),
      retry(this.retry()),
    );
  }

  userItemCount$(acc: string, first: number, skip: number): Observable<ItemEntity[]> {
    return this.userItemsCountGQL.fetch({ userAddress: acc, first, skip }).pipe(
      map(x => (x?.data?.itemEntities ?? []) as ItemEntity[]),
      retry(this.retry()),
    );
  }

  lastPvpGuild$(guildId: string): Observable<PvpGuildEntity[]> {
    return this.pvpGuildByGuildGQL.fetch({ guildId }).pipe(
      map(x => (x?.data?.pvpGuildEntities ?? []) as PvpGuildEntity[]),
      retry(this.retry()),
    );
  }

  pvpLeaderboardByWeekAndBiome$(week: string, biome: number): Observable<PvpGuildEntity[]> {
    return this.pvpGuildLeaderboardGQL.fetch({ week, biome }).pipe(
      map(x => (x?.data?.pvpGuildEntities ?? []) as PvpGuildEntity[]),
      retry(this.retry()),
    );
  }

  pvpFightByWeekAndAccount$(
    account: string,
    epochWeek: string,
    first: number,
    skip: number,
  ): Observable<PvpFightEntity[]> {
    return this.pvpFightByEpochWeekGQL.fetch({ account, epochWeek, first, skip }).pipe(
      map(x => (x?.data?.pvpFightEntities ?? []) as PvpFightEntity[]),
      retry(this.retry()),
    );
  }

  lastItemOwner$(metaId: string, user: string): Observable<ItemEntity[]> {
    return this.lastItemOwnerGQL.fetch({ metaId, user }).pipe(
      map(x => (x?.data?.itemEntities ?? []) as ItemEntity[]),
      retry(this.retry()),
    );
  }

  pawnshopPositionFloor$(itemAdr: string): Observable<number> {
    return this.pawnshopPositionFloorGQL.fetch({ itemAdr: itemAdr.toLowerCase() }).pipe(
      map(x => (x?.data?.pawnshopPositionEntities ?? []) as PawnshopPositionEntity[]),
      map(x => {
        if (x && x.length !== 0) {
          return Number(x[0].acquiredAmount);
        } else {
          return 0;
        }
      }),
      retry(this.retry()),
    );
  }

  story$(storyId: string): Observable<StoryEntity> {
    return this.storyGQL.fetch({ storyId }).pipe(
      map(x => x.data.storyEntity as StoryEntity),
      retry(this.retry()),
    );
  }

  rewardPool$(id: string): Observable<RewardPoolEntity> {
    return this.rewardPoolGQL.fetch({ id }).pipe(
      map(x => x.data.rewardPoolEntity as RewardPoolEntity),
      retry(this.retry()),
    );
  }

  firstBossCompleteByHero$(hero: string): Observable<FirstBossCompletedEntity[]> {
    console.log('>>>>>>>>>>>>>> firstBossCompleteByHero$', hero);
    return this.firstBossCompletedByHeroGQL.fetch({ hero }).pipe(
      map(x => {
        if (x && x.data && x.data.firstBossCompletedEntities.length > 0) {
          return x.data.firstBossCompletedEntities as FirstBossCompletedEntity[];
        }
        return [];
      }),
      retry(this.retry()),
    );
  }

  heroesTopList$(chunk = 1000): Observable<HeroEntity[]> {
    let skip = 0;
    return this.heroesTopListPaginated$(chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.heroesTopListPaginated$(chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as HeroEntity[]),
    );
  }

  heroesTopListPaginated$(
    first: number,
    skip: number,
    heroClass: number[] = [],
    orderBy: HeroEntity_OrderBy = HeroEntity_OrderBy.Score,
    orderDirection: OrderDirection = OrderDirection.Desc,
  ): Observable<HeroEntity[]> {
    return this.heroesTopListGQL.fetch({ first: first, skip: skip, heroClass, orderBy, orderDirection }).pipe(
      map(x => x?.data?.heroEntities ?? []),
      map(e => e.map(el => el as HeroEntity)),
      retry(this.retry()),
    );
  }

  heroesTopListAccountPaginated$(
    first: number,
    skip: number,
    user: string,
    heroClass: number[] = [],
    orderBy: HeroEntity_OrderBy = HeroEntity_OrderBy.Score,
    orderDirection: OrderDirection = OrderDirection.Desc,
  ): Observable<HeroEntity[]> {
    return this.heroesTopListAccountGQL
      .fetch({ first: first, skip: skip, user: user.toLowerCase(), heroClass, orderBy, orderDirection })
      .pipe(
        map(x => x?.data?.heroEntities ?? []),
        map(e => e.map(el => el as HeroEntity)),
        retry(this.retry()),
      );
  }

  heroesMeta$(): Observable<HeroMetaEntity[]> {
    return this.heroesMetaGQL.fetch().pipe(
      map(x => (x?.data?.heroMetaEntities ?? []).map(e => e as HeroMetaEntity)),
      retry(this.retry()),
    );
  }

  heroMetaByAddress$(heroAdr: string): Observable<HeroMetaEntity[]> {
    return this.heroMetaByAddressGQL
      .fetch({
        heroAdr,
      })
      .pipe(
        map(x => x.data.heroMetaEntities),
        filter(e => e.length !== 0),
        map(e => e.map(el => el as HeroMetaEntity)),
        retry(this.retry()),
      );
  }

  chamber$(chamberAdr: string): Observable<ChamberEntity> {
    return this.chamberGQL.fetch({ chamber: chamberAdr.toLowerCase() }).pipe(
      map(x => x.data.chamberEntity),
      map(e => e as ChamberEntity),
      retry(this.retry()),
    );
  }

  dungeon$(dungeonAdr: string): Observable<DungeonEntity> {
    return this.dungeonGQL.fetch({ dungeonAdr: dungeonAdr.toLowerCase() }).pipe(
      map(x => x.data.dungeonEntity),
      retry(this.retry()),
      map(x => x as DungeonEntity),
    );
  }

  freeDungeons$(biome: number, ngLevel: number, first: number, skip: number): Observable<DungeonEntity[]> {
    return this.freeDungeonsGQL.fetch({ biome: biome, ngLevel, first, skip }).pipe(
      map(x => x?.data?.dungeonEntities ?? []),
      retry(this.retry()),
      map(x => x.map(d => d as DungeonEntity)),
    );
  }

  allFreeDungeons$(biome: number, ngLevel: number, chunk = 1000): Observable<DungeonEntity[]> {
    let skip = 0;
    return this.freeDungeons$(biome, ngLevel, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.freeDungeons$(biome, ngLevel, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as DungeonEntity[]),
    );
  }

  usersItems$(userAddress: string, chunk = 1000, isOnlyCons = false): Observable<ItemEntity[]> {
    let skip = 0;
    let lastId = '';
    return this.userItemsPaginated$(chunk, lastId, userAddress.toLowerCase(), isOnlyCons).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          lastId = pos[pos.length - 1].id;
          return this.userItemsPaginated$(chunk, lastId, userAddress.toLowerCase(), isOnlyCons);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as ItemEntity[]),
      map(r =>
        r.sort((a, b) => {
          if (a.meta.itemType < b.meta.itemType) return 1;
          if (a.meta.itemType > b.meta.itemType) return -1;
          if (a.meta.level < b.meta.level) return 1;
          if (a.meta.level > b.meta.level) return -1;
          if (a.meta.id < b.meta.id) return -1;
          if (a.meta.id > b.meta.id) return 1;
          if (a.itemId < b.itemId) return 1;
          if (a.itemId > b.itemId) return -1;
          return 0;
        }),
      ),
    );
  }

  userOtherItemsUse$(userAddress: string, chunk = 1000): Observable<ItemEntity[]> {
    let skip = 0;
    return this.userOtherItemsUsePaginated$(chunk, 0, userAddress.toLowerCase()).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.userOtherItemsUsePaginated$(chunk, skip, userAddress.toLowerCase());
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as ItemEntity[]),
      map(r =>
        r.sort((a, b) => {
          if (a.meta.itemType < b.meta.itemType) return 1;
          if (a.meta.itemType > b.meta.itemType) return -1;
          if (a.meta.level < b.meta.level) return 1;
          if (a.meta.level > b.meta.level) return -1;
          if (a.meta.id < b.meta.id) return -1;
          if (a.meta.id > b.meta.id) return 1;
          if (a.itemId < b.itemId) return 1;
          if (a.itemId > b.itemId) return -1;
          return 0;
        }),
      ),
    );
  }

  heroSandboxItems$(hero: string, chunk = 1000): Observable<ItemEntity[]> {
    let skip = 0;
    return this.heroSandboxPaginated$(chunk, 0, hero.toLowerCase()).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.heroSandboxPaginated$(chunk, skip, hero.toLowerCase());
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as ItemEntity[]),
      map(items => items.filter(item => !isExpiredItem(item))),
      map(r =>
        r.sort((a, b) => {
          if (a.meta.itemType < b.meta.itemType) return 1;
          if (a.meta.itemType > b.meta.itemType) return -1;
          if (a.meta.level < b.meta.level) return 1;
          if (a.meta.level > b.meta.level) return -1;
          if (a.meta.id < b.meta.id) return -1;
          if (a.meta.id > b.meta.id) return 1;
          if (a.itemId < b.itemId) return 1;
          if (a.itemId > b.itemId) return -1;
          return 0;
        }),
      ),
    );
  }

  allItemMetas$(chunk = 1000): Observable<ItemMetaEntity[]> {
    let skip = 0;
    return this.itemMetaList$(chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.itemMetaList$(chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as ItemMetaEntity[]),
    );
  }

  allItemUnion$(chunk = 1000): Observable<ItemUnionEntity[]> {
    let skip = 0;
    return this.itemUnionList$(chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.itemUnionList$(chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as ItemUnionEntity[]),
    );
  }

  allLeaderboardFromWeek$(week: number, chunk = 1000): Observable<WeekUserAirdropStatEntity[]> {
    let skip = 0;
    return this.leaderboardFromWeek$(week, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.leaderboardFromWeek$(week, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as WeekUserAirdropStatEntity[]),
    );
  }

  allLeaderboardByWeek$(week: number, chunk = 1000): Observable<WeekUserAirdropStatEntity[]> {
    let skip = 0;
    return this.leaderboardByWeek$(week, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.leaderboardByWeek$(week, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as WeekUserAirdropStatEntity[]),
    );
  }

  allLeaderboardByUser$(user: string, chunk = 1000): Observable<WeekUserAirdropStatEntity[]> {
    let skip = 0;
    return this.leaderboardByUser$(user, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.leaderboardByUser$(user, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as WeekUserAirdropStatEntity[]),
    );
  }

  allLeaderboardTotalPoints$(chunk = 1000): Observable<WeekTotalAirdropEntity[]> {
    let skip = 0;
    return this.leaderboardTotalPoints$(chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.leaderboardTotalPoints$(chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as WeekTotalAirdropEntity[]),
    );
  }

  allHeroActionsByTimeAndFromTimestamp$(
    hero: string,
    action: number,
    timestamp: number,
    chunk = 1000,
  ): Observable<HeroAction[]> {
    let skip = 0;
    return this.heroActionsByTimeAndFromTimestamp$(hero, action, timestamp, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.heroActionsByTimeAndFromTimestamp$(hero, action, timestamp, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as HeroAction[]),
    );
  }

  allGuildReinforcement$(guildId: string, chunk = 1000): Observable<GuildReinforcementEntity[]> {
    let skip = 0;
    return this.guildReinforcement$(guildId, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.guildReinforcement$(guildId, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as GuildReinforcementEntity[]),
    );
  }

  allBossCompletedBetweenTimestamp$(
    timestampFrom: string,
    timestampTo: string,
    chunk = 1000,
  ): Observable<UserBossCompletedEntity[]> {
    let skip = 0;
    return this.bossCompletedBetweenTimestamp$(timestampFrom, timestampTo, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.bossCompletedBetweenTimestamp$(timestampFrom, timestampTo, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as UserBossCompletedEntity[]),
    );
  }

  allBossCompletedBetweenTimestampWithoutBlock$(
    timestampFrom: string,
    timestampTo: string,
    chunk = 1000,
  ): Observable<UserBossCompletedEntity[]> {
    let skip = 0;
    return this.bossCompletedBetweenTimestampWithoutBlock$(timestampFrom, timestampTo, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.bossCompletedBetweenTimestampWithoutBlock$(timestampFrom, timestampTo, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as UserBossCompletedEntity[]),
    );
  }

  allPvpFightsBetweenTimestamp$(
    timestampFrom: string,
    timestampTo: string,
    chunk = 1000,
  ): Observable<HeroPvpFightHistoryEntity[]> {
    let skip = 0;
    return this.pvpFightsBetweenTimestamp$(timestampFrom, timestampTo, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.pvpFightsBetweenTimestamp$(timestampFrom, timestampTo, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as HeroPvpFightHistoryEntity[]),
    );
  }

  allItemMetaInAddress$(ids: string[], chunk = 1000): Observable<ItemMetaEntity[]> {
    let skip = 0;
    return this.itemMetaInAddress$(ids, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.itemMetaInAddress$(ids, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as ItemMetaEntity[]),
    );
  }

  allBossCompletedAfterTimestamp$(timestamp: string, chunk = 1000): Observable<UserBossCompletedEntity[]> {
    let skip = 0;
    return this.bossCompletedAfterTimestamp$(timestamp, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.bossCompletedAfterTimestamp$(timestamp, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as UserBossCompletedEntity[]),
    );
  }

  allBossCompletedInPeriod(
    startTimestamp: string,
    endTimestamp: string,
    chunk = 1000,
  ): Observable<UserBossCompletedEntity[]> {
    return this.bossCompletedAfterTimestamp$(startTimestamp, chunk, 0).pipe(
      reduce((acc, value) => acc.concat(value), [] as UserBossCompletedEntity[]),
    );
  }

  allGuildMembers$(chunk = 1000): Observable<GuildMemberEntity[]> {
    let skip = 0;
    return this.guildMembers$(chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.guildMembers$(chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as GuildMemberEntity[]),
    );
  }

  allFirsBossCompletedByUser$(user: string, chunk = 1000): Observable<FirstBossCompletedEntity[]> {
    let skip = 0;
    return this.firstBossCompletedByUser$(user, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.firstBossCompletedByUser$(user, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as FirstBossCompletedEntity[]),
    );
  }

  allTiers$(chunk = 1000): Observable<TierEntity[]> {
    let skip = 0;
    return this.tierList$(chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.tierList$(chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as TierEntity[]),
    );
  }

  allHeroesInIds$(ids: string[], chunk = 1000): Observable<HeroEntity[]> {
    let skip = 0;
    return this.heroesInIds$(ids, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.heroesInIds$(ids, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as HeroEntity[]),
    );
  }

  allLastPvpFightByGuild$(guild: string, chunk = 1000): Observable<PvpFightEntity[]> {
    let skip = 0;
    return this.lastPvpFightByGuild$(guild, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.lastPvpFightByGuild$(guild, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as PvpFightEntity[]),
    );
  }

  allLastPvpFightFromWeek$(week: string, chunk = 1000): Observable<PvpFightEntity[]> {
    let skip = 0;
    return this.lastPvpFightFromWeek$(week, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.lastPvpFightFromWeek$(week, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as PvpFightEntity[]),
    );
  }

  allPvpHeroByWeek$(week: string, chunk = 1000): Observable<PvpGuildHeroEntity[]> {
    let skip = 0;
    return this.pvpGuildHeroByWeek$(week, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.pvpGuildHeroByWeek$(week, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as PvpGuildHeroEntity[]),
    );
  }

  allPvpHeroByWeekAndBiome$(week: string, biome: number, chunk = 1000): Observable<PvpGuildHeroEntity[]> {
    let skip = 0;
    return this.pvpGuildHeroByWeekAndBiome$(week, biome, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.pvpGuildHeroByWeekAndBiome$(week, biome, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as PvpGuildHeroEntity[]),
    );
  }

  allGuildStakeData$(chunk = 1000): Observable<GuildStakeEntity[]> {
    let skip = 0;
    return this.guildStakeData$(chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.guildStakeData$(chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as GuildStakeEntity[]),
    );
  }

  allTransactions$(chunk = 1000): Observable<TransactionEntity[]> {
    let skip = 0;
    return this.transactions$(chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.transactions$(chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as TransactionEntity[]),
    );
  }

  allUserItemCount$(account: string, chunk = 1000): Observable<ItemEntity[]> {
    let skip = 0;
    return this.userItemCount$(account, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.userItemCount$(account, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as ItemEntity[]),
    );
  }

  allStakedHeroesByBiome$(biome: number, chunk = 1000): Observable<HeroEntity[]> {
    let skip = 0;
    return this.heroesByBiome$(biome, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.heroesByBiome$(biome, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as HeroEntity[]),
    );
  }

  allPvpGuildLeaderboardByWeek$(week: string, chunk = 1000): Observable<PvpGuildEntity[]> {
    let skip = 0;
    return this.pvpGuildLeaderboardByWeek$(week, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.pvpGuildLeaderboardByWeek$(week, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as PvpGuildEntity[]),
    );
  }

  allHeroesForFight$(account: string, minLvl: number, chunk = 1000): Observable<HeroEntity[]> {
    let skip = 0;
    return this.heroesForFight$(account, minLvl, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.heroesForFight$(account, minLvl, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as HeroEntity[]),
    );
  }

  allShelterItemsLimitByDayAndGuild$(
    shelter: string,
    epochDay: string,
    chunk = 1000,
  ): Observable<ShelterItemLimitEntity[]> {
    let skip = 0;
    return this.shelterItemsLimitByDayAndGuild$(shelter, epochDay, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.shelterItemsLimitByDayAndGuild$(shelter, epochDay, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as ShelterItemLimitEntity[]),
    );
  }

  allGuilds$(chunk = 1000): Observable<GuildEntity[]> {
    let skip = 0;
    return this.guilds$(chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.guilds$(chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as GuildEntity[]),
    );
  }

  allShelters$(chunk = 1000): Observable<ShelterEntity[]> {
    let skip = 0;
    return this.shelters$(chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.shelters$(chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as ShelterEntity[]),
    );
  }

  allShelterAuctions$(chunk = 1000): Observable<ShelterAuctionEntity[]> {
    let skip = 0;
    return this.shelterAuctions$(chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.shelterAuctions$(chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as ShelterAuctionEntity[]),
    );
  }

  allGuildRequests$(user: string, chunk = 1000): Observable<GuildRequestEntity[]> {
    let skip = 0;
    return this.guildRequestsByUser$(user, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.guildRequestsByUser$(user, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as GuildRequestEntity[]),
    );
  }

  allGuildRequestsByGuild$(guild: string, chunk = 1000): Observable<GuildRequestEntity[]> {
    let skip = 0;
    return this.guildRequestsByGuild$(guild, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.guildRequestsByGuild$(guild, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as GuildRequestEntity[]),
    );
  }

  allTransactionGtTimestamp$(
    from: string,
    to: string,
    timestamp: string,
    chunk = 1000,
  ): Observable<TokenTransactionEntity[]> {
    let skip = 0;
    return this.transactionGtTimestamp$(from, to, timestamp, chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.transactionGtTimestamp$(from, to, timestamp, chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as TokenTransactionEntity[]),
    );
  }

  heroesRefCode$(chunk = 1000): Observable<HeroEntity[]> {
    let skip = 0;
    return this.heroesRefCodePaginated$(chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.heroesRefCodePaginated$(chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as HeroEntity[]),
    );
  }

  heroesRefCodeByAddress$(address: string, chunk = 1000): Observable<HeroEntity[]> {
    let skip = 0;
    return this.heroesRefCodeByAddressPaginated$(chunk, 0, address).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.heroesRefCodeByAddressPaginated$(chunk, skip, address);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as HeroEntity[]),
    );
  }

  allHeroesForGuildStake$(address: string, biome: number, chunk = 1000): Observable<HeroEntity[]> {
    let skip = 0;
    return this.heroesForGuildStakePaginated$(chunk, 0, address, biome).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.heroesForGuildStakePaginated$(chunk, skip, address, biome);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as HeroEntity[]),
    );
  }

  userItemsPaginated$(
    first: number,
    lastId: string,
    userAddress: string,
    isOnlyCons: boolean,
  ): Observable<ItemEntity[]> {
    return (isOnlyCons ? this.userConsGQL : this.userItemsGQL)
      .fetch({ first: first, lastId, userAddress: userAddress })
      .pipe(
        map(x => x?.data?.itemEntities ?? []),
        map(e => e.map(el => el as ItemEntity)),
        retry(this.retry()),
      );
  }

  userOtherItemsUsePaginated$(first: number, skip: number, userAddress: string): Observable<ItemEntity[]> {
    return this.userOtherUseGQL.fetch({ first: first, skip: skip, userAddress: userAddress }).pipe(
      map(x => x?.data?.itemEntities ?? []),
      map(e => e.map(el => el as ItemEntity)),
      retry(this.retry()),
    );
  }

  heroSandboxPaginated$(first: number, skip: number, hero: string): Observable<ItemEntity[]> {
    return this.heroSandboxItemsGQL.fetch({ first: first, skip: skip, hero: hero }).pipe(
      map(x => x?.data?.itemEntities ?? []),
      map(e => e.map(el => el as ItemEntity)),
      retry(this.retry()),
    );
  }

  itemMetaList$(first: number, skip: number): Observable<ItemMetaEntity[]> {
    return this.itemMetaListGQL.fetch({ first: first, skip: skip }).pipe(
      map(x => x?.data?.itemMetaEntities ?? []),
      map(e => e.map(el => el as ItemMetaEntity)),
      retry(this.retry()),
    );
  }

  itemUnionList$(first: number, skip: number): Observable<ItemUnionEntity[]> {
    return this.itemUnionListGQL.fetch({ first: first, skip: skip }).pipe(
      map(x => x?.data?.itemUnionEntities ?? []),
      map(e => e.map(el => el as ItemUnionEntity)),
      retry(this.retry()),
    );
  }

  leaderboardFromWeek$(week: number, first: number, skip: number): Observable<WeekUserAirdropStatEntity[]> {
    return this.leaderboardFromWeekGQL.fetch({ week: week + '', first: first, skip: skip }).pipe(
      map(x => x?.data?.weekUserAirdropStatEntities ?? []),
      map(e => e.map(el => el as WeekUserAirdropStatEntity)),
      retry(this.retry()),
    );
  }

  leaderboardByWeek$(week: number, first: number, skip: number): Observable<WeekUserAirdropStatEntity[]> {
    return this.leaderboardByWeekGQL.fetch({ week: week + '', first: first, skip: skip }).pipe(
      map(x => x?.data?.weekUserAirdropStatEntities ?? []),
      map(e => e.map(el => el as WeekUserAirdropStatEntity)),
      retry(this.retry()),
    );
  }

  leaderboardByUser$(user: string, first: number, skip: number): Observable<WeekUserAirdropStatEntity[]> {
    return this.leaderboardByUserGQL.fetch({ account: user, first: first, skip: skip }).pipe(
      map(x => x?.data?.weekUserAirdropStatEntities ?? []),
      map(e => e.map(el => el as WeekUserAirdropStatEntity)),
      retry(this.retry()),
    );
  }

  leaderboardTotalPoints$(first: number, skip: number): Observable<WeekTotalAirdropEntity[]> {
    return this.leaderboardTotalPointsGQL.fetch({ first: first, skip: skip }).pipe(
      map(x => x?.data?.weekTotalAirdropEntities ?? []),
      map(e => e.map(el => el as WeekTotalAirdropEntity)),
      retry(this.retry()),
    );
  }

  heroActionsByTimeAndFromTimestamp$(
    hero: string,
    action: number,
    timestamp: number,
    first: number,
    skip: number,
  ): Observable<HeroAction[]> {
    return this.heroActionsByTimeAndFromTimestampGQL
      .fetch({ hero, actionType: action, timestamp: timestamp + '', first: first, skip: skip })
      .pipe(
        map(x => x?.data?.heroActions ?? []),
        map(e => e.map(el => el as HeroAction)),
        retry(this.retry()),
      );
  }

  guildReinforcement$(guildId: string, first: number, skip: number): Observable<GuildReinforcementEntity[]> {
    return this.guildReinforcementGQL.fetch({ guildId, first: first, skip: skip }).pipe(
      map(x => x?.data?.guildReinforcementEntities ?? []),
      map(e => e.map(el => el as GuildReinforcementEntity)),
      retry(this.retry()),
    );
  }

  itemByMetaName$(user: string, name: string): Observable<ItemEntity[]> {
    return this.itemByOwnerAndMetaNameGQL.fetch({ metaName: name, user }).pipe(
      map(x => x?.data?.itemEntities ?? []),
      map(e => e.map(el => el as ItemEntity)),
      retry(this.retry()),
    );
  }

  bossCompletedBetweenTimestamp$(
    timestampFrom: string,
    timestampTo: string,
    first: number,
    skip: number,
  ): Observable<UserBossCompletedEntity[]> {
    return this.bossCompletedBetweenTimestamp
      .fetch({ timestampGt: timestampFrom, timestampLt: timestampTo, first: first, skip: skip })
      .pipe(
        map(x => x?.data?.userBossCompletedEntities ?? []),
        map(e => e.map(el => el as UserBossCompletedEntity)),
        retry(this.retry()),
      );
  }

  bossCompletedBetweenTimestampWithoutBlock$(
    timestampFrom: string,
    timestampTo: string,
    first: number,
    skip: number,
  ): Observable<UserBossCompletedEntity[]> {
    return this.bossCompletedBetweenTimestampWithoutBlockGQL
      .fetch({ timestampGt: timestampFrom, timestampLt: timestampTo, first: first, skip: skip })
      .pipe(
        map(x => x?.data?.userBossCompletedEntities ?? []),
        map(e => e.map(el => el as UserBossCompletedEntity)),
        retry(this.retry()),
      );
  }

  pvpFightsBetweenTimestamp$(
    timestampFrom: string,
    timestampTo: string,
    first: number,
    skip: number,
  ): Observable<HeroPvpFightHistoryEntity[]> {
    return this.pvpFightsBetweenTimestampGQL
      .fetch({ timestampGt: timestampFrom, timestampLt: timestampTo, first: first, skip: skip })
      .pipe(
        map(x => x?.data?.heroPvpFightHistoryEntities ?? []),
        map(e => e.map(el => el as HeroPvpFightHistoryEntity)),
        retry(this.retry()),
      );
  }

  weekAirdropRootFromWeek$(fromWeek: string): Observable<WeekAirdropRootEntity[]> {
    return this.weekAirdropRootFromWeek.fetch({ fromWeek: fromWeek }).pipe(
      map(x => x?.data?.weekAirdropRootEntities ?? []),
      map(e => e.map(el => el as WeekAirdropRootEntity)),
      retry(this.retry()),
    );
  }

  weekGasAirdropByUser$(user: string, fromWeek: string): Observable<WeekGasUserAirdropStatEntity[]> {
    return this.gasWeekAirdropByUserGQL.fetch({ user, fromWeek: fromWeek }).pipe(
      map(x => x?.data?.weekGasUserAirdropStatEntities ?? []),
      map(e => e.map(el => el as WeekGasUserAirdropStatEntity)),
      retry(this.retry()),
    );
  }

  itemMetaInAddress$(ids: string[], first: number, skip: number): Observable<ItemMetaEntity[]> {
    return this.itemMetaInAddressGQL.fetch({ ids: ids, first: first, skip: skip }).pipe(
      map(x => x?.data?.itemMetaEntities ?? []),
      map(e => e.map(el => el as ItemMetaEntity)),
      retry(this.retry()),
    );
  }

  bossCompletedAfterTimestamp$(timestamp: string, first: number, skip: number): Observable<UserBossCompletedEntity[]> {
    return this.bossCompletedAfterTimestampGQL.fetch({ timestamp: timestamp, first: first, skip: skip }).pipe(
      map(x => x?.data?.userBossCompletedEntities ?? []),
      map(e => e.map(el => el as UserBossCompletedEntity)),
      retry(this.retry()),
    );
  }

  guildMembers$(first: number, skip: number): Observable<GuildMemberEntity[]> {
    return this.guildMembersGQL.fetch({ first: first, skip: skip }).pipe(
      map(x => x?.data?.guildMemberEntities ?? []),
      map(e => e.map(el => el as GuildMemberEntity)),
      retry(this.retry()),
    );
  }

  firstBossCompletedByUser$(user: string, first: number, skip: number): Observable<FirstBossCompletedEntity[]> {
    return this.firstBossCompletedByUserGQL.fetch({ user: user, first: first, skip: skip }).pipe(
      map(x => x?.data?.firstBossCompletedEntities ?? []),
      map(e => e.map(el => el as FirstBossCompletedEntity)),
      retry(this.retry()),
    );
  }

  tierList$(first: number, skip: number): Observable<TierEntity[]> {
    return this.tierGQL.fetch({ first: first, skip: skip }).pipe(
      map(x => x?.data?.tierEntities ?? []),
      map(e => e.map(el => el as TierEntity)),
      retry(this.retry()),
    );
  }

  heroesInIds$(ids: string[], first: number, skip: number): Observable<HeroEntity[]> {
    return this.heroesInAddressDataGQL.fetch({ ids: ids, first: first, skip: skip }).pipe(
      map(x => x?.data?.heroEntities ?? []),
      map(e => e.map(el => el as HeroEntity)),
      retry(this.retry()),
    );
  }

  heroesByBiome$(biome: number, first: number, skip: number): Observable<HeroEntity[]> {
    return this.heroesByBiomeDataGQL.fetch({ biome: biome, first: first, skip: skip }).pipe(
      map(x => x?.data?.heroEntities ?? []),
      map(e => e.map(el => el as HeroEntity)),
      retry(this.retry()),
    );
  }

  pvpGuildLeaderboardByWeek$(week: string, first: number, skip: number): Observable<PvpGuildEntity[]> {
    return this.pvpGuildLeaderboardInWeek.fetch({ week: week, first: first, skip: skip }).pipe(
      map(x => x?.data?.pvpGuildEntities ?? []),
      map(e => e.map(el => el as PvpGuildEntity)),
      retry(this.retry()),
    );
  }

  heroesForFight$(account: string, minLvl: number, first: number, skip: number): Observable<HeroEntity[]> {
    return this.heroesForFightGQL.fetch({ minLvl: minLvl, first: first, skip: skip, account }).pipe(
      map(x => x?.data?.heroEntities ?? []),
      map(e => e.map(el => el as HeroEntity)),
      retry(this.retry()),
    );
  }

  shelterItemsLimitByDayAndGuild$(
    shelter: string,
    epochDay: string,
    first: number,
    skip: number,
  ): Observable<ShelterItemLimitEntity[]> {
    return this.shelterItemsByDayAndGuildDataGQL.fetch({ epochDay, shelter, first: first, skip: skip }).pipe(
      map(x => x?.data?.shelterItemLimitEntities ?? []),
      map(e => e.map(el => el as ShelterItemLimitEntity)),
      retry(this.retry()),
    );
  }

  guilds$(first: number, skip: number): Observable<GuildEntity[]> {
    return this.guildsDataGQL.fetch({ first: first, skip: skip }).pipe(
      map(x => x?.data?.guildEntities ?? []),
      map(e => e.map(el => el as GuildEntity)),
      retry(this.retry()),
    );
  }

  shelters$(first: number, skip: number): Observable<ShelterEntity[]> {
    return this.sheltersDataGQL.fetch({ first: first, skip: skip }).pipe(
      map(x => x?.data?.shelterEntities ?? []),
      map(e => e.map(el => el as ShelterEntity)),
      retry(this.retry()),
    );
  }

  shelterAuctions$(first: number, skip: number): Observable<ShelterAuctionEntity[]> {
    return this.shelterAuctionsDataGQL.fetch({ first: first, skip: skip }).pipe(
      map(x => x?.data?.shelterAuctionEntities ?? []),
      map(e => e.map(el => el as ShelterAuctionEntity)),
      retry(this.retry()),
    );
  }

  guildRequestsByUser$(user: string, first: number, skip: number): Observable<GuildRequestEntity[]> {
    return this.guildRequestByUserDataGQL.fetch({ user: user, first: first, skip: skip }).pipe(
      map(x => x?.data?.guildRequestEntities ?? []),
      map(e => e.map(el => el as GuildRequestEntity)),
      retry(this.retry()),
    );
  }

  guildRequestsByGuild$(guild: string, first: number, skip: number): Observable<GuildRequestEntity[]> {
    return this.guildRequestByGuildGQL.fetch({ guildId: guild, first: first, skip: skip }).pipe(
      map(x => x?.data?.guildRequestEntities ?? []),
      map(e => e.map(el => el as GuildRequestEntity)),
      retry(this.retry()),
    );
  }

  transactionGtTimestamp$(
    from: string,
    to: string,
    timestamp: string,
    first: number,
    skip: number,
  ): Observable<TokenTransactionEntity[]> {
    return this.transactionGtTimestampData
      .fetch({ from: from, to: to, timestamp: timestamp, first: first, skip: skip })
      .pipe(
        map(x => x?.data?.tokenTransactionEntities ?? []),
        map(e => e.map(el => el as TokenTransactionEntity)),
        retry(this.retry()),
      );
  }

  heroesRefCodePaginated$(first: number, skip: number): Observable<HeroEntity[]> {
    return this.heroesRefCodeGQL.fetch({ first: first, skip: skip }).pipe(
      map(x => x?.data?.heroEntities ?? []),
      map(e => e.map(el => el as HeroEntity)),
      retry(this.retry()),
    );
  }

  heroesRefCodeByAddressPaginated$(first: number, skip: number, address: string): Observable<HeroEntity[]> {
    return this.heroesRefCodeByAddressGQL.fetch({ first: first, skip: skip, address }).pipe(
      map(x => x?.data?.heroEntities ?? []),
      map(e => e.map(el => el as HeroEntity)),
      retry(this.retry()),
    );
  }

  pawnshop$(): Observable<PawnshopEntity> {
    return this.pawnshopGQL.fetch().pipe(
      map(x => x?.data?.pawnshopEntities ?? []),
      map(e => e[0] as PawnshopEntity),
      retry(this.retry()),
    );
  }

  pawnshopPositions$(chunk = 1000): Observable<PawnshopPositionEntity[]> {
    let skip = 0;
    return this.pawnshopPositionsPaginated$(chunk, 0).pipe(
      expand(pos => {
        if (pos.length !== 0) {
          skip += chunk;
          return this.pawnshopPositionsPaginated$(chunk, skip);
        }
        return EMPTY;
      }),
      reduce((acc, value) => acc.concat(value), [] as PawnshopPositionEntity[]),
    );
  }

  pawnshopPositionsPaginated$(first: number, skip: number): Observable<PawnshopPositionEntity[]> {
    return this.pawnshopPositionsGQL.fetch({ first: first, skip: skip }).pipe(
      map(x => x?.data?.pawnshopPositionEntities ?? []),
      map(e => e.map(el => el as PawnshopPositionEntity)),
      retry(this.retry()),
    );
  }

  pawnshopHistoryPaginated$(first: number, skip: number, users: string[]): Observable<PawnshopPositionHistoryEntity[]> {
    return this.pawnshopHistoryGQL.fetch({ first: first, skip: skip, userAdr: users }).pipe(
      map(x => x?.data?.pawnshopPositionHistoryEntities ?? []),
      map(e => e.map(el => el as PawnshopPositionHistoryEntity)),
      retry(this.retry()),
    );
  }

  heroesForGuildStakePaginated$(first: number, skip: number, user: string, biome: number): Observable<HeroEntity[]> {
    return this.heroesForGuildStakeGQL.fetch({ first: first, skip: skip, account: user.toLowerCase(), biome }).pipe(
      map(x => x?.data?.heroEntities ?? []),
      map(e => e.map(el => el as HeroEntity)),
      retry(this.retry()),
    );
  }

  heroCustomData$(dataIndexes: string[], heroAdr: string, heroId: string): Observable<HeroCustomData[]> {
    return this.heroCustomDataGQL
      .fetch({
        dataIndexes: dataIndexes,
        // convert to id heroAdr-heroId
        heroId: `${heroAdr}-${heroId}`,
      })
      .pipe(
        map(x => x.data.heroCustomDatas),
        map(e => e.map(el => el as HeroCustomData)),
        retry(this.retry()),
      );
  }

  globalCustomData$(ids: string[]): Observable<GlobalCustomDataEntity[]> {
    return this.globalCustomDataGQL
      .fetch({
        ids: ids,
      })
      .pipe(
        map(x => x.data.globalCustomDataEntities),
        map(e => e.map(el => el as GlobalCustomDataEntity)),
        retry(this.retry()),
      );
  }

  tokenTransactionsFrom$(
    from: string,
    token: string,
    first: number = 10,
    skip: number = 0,
  ): Observable<TokenTransactionEntity[]> {
    return this.tokenTransactionFromGQL.fetch({ from: from, tokenAdr: token, first: first, skip: skip }).pipe(
      map(x => x.data.tokenTransactionEntities),
      map(e => e.map(el => el as TokenTransactionEntity)),
      retry(this.retry()),
    );
  }

  tokenTransactionsTo$(
    to: string,
    token: string,
    first: number = 10,
    skip: number = 0,
  ): Observable<TokenTransactionEntity[]> {
    return this.tokenTransactionsToGQL.fetch({ to: to, tokenAdr: token, first: first, skip: skip }).pipe(
      map(x => x.data.tokenTransactionEntities),
      map(e => e.map(el => el as TokenTransactionEntity)),
      retry(this.retry()),
    );
  }

  lastTokenTransactions(user: string, token: string): Observable<TokenTransactionEntity[]> {
    return forkJoin([this.tokenTransactionsFrom$(user, token), this.tokenTransactionsTo$(user, token)]).pipe(
      map(([from, to]) => {
        const allTransactions = from.concat(to);
        const sortedTransactions = allTransactions.sort((a, b) => Number(b.timestamp) - Number(a.timestamp));
        return sortedTransactions.slice(0, 10);
      }),
    );
  }
}
